// extracted by mini-css-extract-plugin
module.exports = {"theme":"Theme_theme__38Gbb"};